import React from 'react'
import {PREFIX_EXT_TERMS} from '@i18n/helpers/terms/constants'
import Checkbox from '@packages/justo-parts/lib/components/fields/Checkbox'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

const nextTermSignatures = (termTypeGroup, termInfoGroup, termSignatures) => {
  const result = termSignatures.map(term => {
    return {...term}
  })
  const extendedTermTypes = [termTypeGroup, `${PREFIX_EXT_TERMS}${termTypeGroup}`]
  const add = result.filter(term => extendedTermTypes.includes(term.termType)).length === 0
  if (add) {
    termInfoGroup.forEach(term => {
      result.push({termType: term.termType, version: term.latestVersion})
    })
    return result
  }
  return result.filter(term => !extendedTermTypes.includes(term.termType))
}

const getCheckboxLabel = (t, {fullLocale, termTypeGroup, websiteName, termInfoGroup}) => {
  const defaultLabel = t(`${termTypeGroup}.checkboxLabel`, {returnObjects: true})
  if (termInfoGroup.some(term => !term.termType.startsWith(PREFIX_EXT_TERMS))) {
    return defaultLabel
  }

  const firtsCustomTerm = termInfoGroup.find(term => term.termType.startsWith(PREFIX_EXT_TERMS))
  if (!firtsCustomTerm) return defaultLabel

  const {checkboxLabel} = firtsCustomTerm
  const presentLabels = Object.values(checkboxLabel).filter(Boolean)
  if (!presentLabels.length) return defaultLabel
  return checkboxLabel
}

export default function Check({fullLocale, termTypeGroup, termInfoGroup, ...otherProps}) {
  const {t} = useTranslation('terms', {})
  const {websiteName, termSignatures, setTermSignatures, setOpenModal, setTermType} = otherProps
  const checkboxLabel = getCheckboxLabel(t, {
    fullLocale,
    termTypeGroup,
    websiteName,
    termInfoGroup
  })

  const {left, link, right} = checkboxLabel || {}
  const optional = termInfoGroup.reduce((optinalAcc, term) => optinalAcc && term.optional, true)
  const extendedTermTypes = [termTypeGroup, `${PREFIX_EXT_TERMS}${termTypeGroup}`]
  const value = !!termSignatures.find(term => extendedTermTypes.includes(term.termType))

  const openModal = type => {
    setOpenModal(true)
    setTermType(type)
  }

  return (
    <>
      <div className={styles.checkbox}>
        <Checkbox
          fieldName={termTypeGroup}
          onChange={() => {
            setTermSignatures(nextTermSignatures(termTypeGroup, termInfoGroup, termSignatures))
          }}
          value={value}
          label={
            <span className={styles.label}>
              {left ? left + ' ' : ''}
              {link ? (
                <a className={styles.labelLink} onClick={() => openModal(termTypeGroup)}>
                  {link}
                </a>
              ) : null}
              {right ? ' ' + right : ''}
              {optional ? ` (${t('optional')})` : ''}
            </span>
          }
        />
      </div>
    </>
  )
}
